module.exports = __webpack_public_path__ + "static/media/arrowRight.238d9d0d.svg";